import { FC } from 'react'

import WhatsAppPrice from './WhatsAppPrice'
import { TPlanSummary } from 'common/cms-types'
import MediaCard from '../cards/new/common/MediaCard'
import useShoppingBag from 'common/useShoppingBag'
import { useRouter } from 'next/router'

interface ConnectWithCustomersProps {
  planSummary: TPlanSummary
}

const ConnectWithCustomers: FC<ConnectWithCustomersProps> = ({
  planSummary,
}) => {
  const router = useRouter()
  const { addPlan } = useShoppingBag()

  const handleBuyNow = () => {
    addPlan(planSummary.slug, 'month', planSummary)
    router.push('/checkout')
  }

  const tagline = (
    <span className='fs-fluid-18-20 fw-bold d-block lh-140 mb-2'>
      Connect with your customers directly, immediately and more effectively.
    </span>
  )

  return (
    <MediaCard
      className='pe-lg-22'
      layout={{ mobile: 'content-top-media-bottom' }}
      imageContainerWidth='32%'
      imageFitPreset='contain-center'
      image={{
        alt: 'Robot holding a phone with WhatsApp logo',
        desktop: {
          src: '/images/new/whatsapp/robot-holding-whatsapp.png',
          dimensions: {
            width: 432,
            height: 483,
          },
        },
        mobile: {
          src: '/images/new/whatsapp/robot-holding-whatsapp.png',
          dimensions: {
            width: 361,
            height: 403,
          },
        },
      }}
      footerContent={
        <div className='d-flex flex-column align-items-center px-4 pb-4 d-lg-none text-center'>
          {tagline}
          <WhatsAppPrice
            onBuyNow={handleBuyNow}
            planSummary={planSummary}
            actionButtonClassName='w-100'
          />
        </div>
      }
    >
      <div className='d-flex flex-column flex-1 px-4 pt-8 pb-lg-10 pb-5 ps-lg-20 pe-lg-8'>
        <h2 className='fs-fluid-24-48 lh-105 fw-semibold mb-2'>
          WhatsApp Business – connect with your customers instantly, anywhere in
          the world.
        </h2>
        <p className='fs-fluid-18-24 fw-semibold lh-114 mb-2'>
          Access professional customer-service tools and more with a
          personalised{' '}
          <strong>WhatsApp for Business virtual phone number</strong> from
          Hoxton Mix.
        </p>
        <div className='d-none d-lg-block'>
          {tagline}
          <WhatsAppPrice onBuyNow={handleBuyNow} planSummary={planSummary} />
        </div>
      </div>
    </MediaCard>
  )
}

export default ConnectWithCustomers
